import type { GraphQLTypes, InputType } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const actionFields = {
  id: true,
  createdAt: true,
  origin: true,
  status: true,
  title: true,
  description: true,
  owner: true,
  dueDate: true,
  effect: true,
  doneAt: true,
} as const

const riskFields = {
  id: true,
  createdAt: true,
  updatedAt: true,
  title: true,
  description: true,
  likelihood: true,
  impact: true,
  severity: true,
  mitigation: true,
  owner: true,
  status: true,
} as const

/** Amélioration continue de l'organisme (#328) : actions et risques, aux admins. */
export const GQL_IMPROVEMENT_ACTIONS = typedGql('query', { scalars })({ improvementActions: actionFields })

export const GQL_CREATE_IMPROVEMENT_ACTION = typedGql('mutation', { scalars })({
  createImprovementAction: [{ input: $('input', 'CreateImprovementActionInput!') }, actionFields],
})

export const GQL_UPDATE_IMPROVEMENT_ACTION = typedGql('mutation', { scalars })({
  updateImprovementAction: [{ input: $('input', 'UpdateImprovementActionInput!') }, actionFields],
})

export const GQL_QUALITY_RISKS = typedGql('query', { scalars })({ qualityRisks: riskFields })

export const GQL_CREATE_QUALITY_RISK = typedGql('mutation', { scalars })({
  createQualityRisk: [{ input: $('input', 'CreateQualityRiskInput!') }, riskFields],
})

export const GQL_UPDATE_QUALITY_RISK = typedGql('mutation', { scalars })({
  updateQualityRisk: [{ input: $('input', 'UpdateQualityRiskInput!') }, riskFields],
})

export type ImprovementAction = InputType<GraphQLTypes['ImprovementActionModel'], typeof actionFields, typeof scalars>
export type QualityRisk = InputType<GraphQLTypes['QualityRiskModel'], typeof riskFields, typeof scalars>
